import React, { Component, Fragment } from 'react';
import { RenderVirtualTable } from './TableComponent'
import { Loading, CustomLoading } from './LoadingComponent';
import { connect } from 'react-redux';
import { Input, Button, ButtonGroup } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { BarPlot, MultLineTsPlot } from './PlotComponent';
import { CSVLink } from "react-csv";
import { colors } from '../shared/data';
import { filtered_data, sort_by, remove_keys_json_array, series_normalize, filtered_json, CustomListSelect, CustomSelect } from './Functions';
import { funds_select_actions } from '../redux/ActionType';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    funds: state.funds,
    fund_params: state.fund_params,
  };
};

class FundsSelect extends Component {
  constructor(props){
      super(props);
      this.state = {
        search_text:null,
        port_tooltip:false,
        sort_col:'',
        sort_active_col:'',
        loading_funds:false,
        msg:null
      };
      this.loadFunds = this.loadFunds.bind(this);
      this.renderHeader = this.renderHeader.bind(this);
  }

  async loadFunds(){
    const result = await this.props.fetchData(
      {
        category:this.props.fund_params.funds_categ, 
        type:this.props.fund_params.use_etf ? "Institucional" : "Retail",
        ref_date:this.props.fund_params.funds_sel_date,
        use_etf:this.props.fund_params.use_etf
      }, 'funds_selected', funds_select_actions);
  }

  renderHeader(){
    return(
      <Fragment>
        <div className="row m-5 justify-content-center">
          <div className="col-auto">
            <h4><b>Selección de Fondos</b></h4>
          </div>
        </div>
        <div className='row mb-2 justify-content-center align-items-center'>
          <div className='col-4'>
            <CustomListSelect
              className="basic-single"
              fontSize={14}
              itemSize={40}
              options={this.props.user_wm.data[this.props.fund_params.use_etf ? 'etf_categories' : 'categories'].map((x,i)=>{
                return {value:x, label:x};
              })}
              value={this.props.fund_params.funds_categ=="" || this.props.fund_params.funds_categ==null ? null : {value:this.props.fund_params.funds_categ, label:this.props.fund_params.funds_categ}}
              isClearable={true}
              isSearchable={true}
              onChange={(e)=>this.props.changeModel('fund_params.funds_categ', e==null ? null:e.value)}  
              placeholder={`seleccionar categoría ${this.props.fund_params.use_etf ? 'ETFs' : 'fondos'}...`}
            />
          </div>
          <div className='col-2'>
            <ButtonGroup size='sm'>
              <Button
                color="dark"
                outline
                onClick={() => {
                  if (this.props.fund_params.use_etf){
                  this.props.changeModel("fund_params.use_etf", false);
                  this.props.changeModel("fund_params.funds_categ", null);
                  }
                }}
                active={!this.props.fund_params.use_etf}
              >
                Fondos
              </Button>
              <Button
                color="dark"
                outline
                onClick={() => {
                  if (!this.props.fund_params.use_etf){
                    this.props.changeModel("fund_params.use_etf", true)
                    this.props.changeModel("fund_params.funds_categ", null)
                  }
                }}
                active={this.props.fund_params.use_etf}
              >
                ETFs
              </Button>
            </ButtonGroup>
          </div>
        </div>
        <div className='row m-3 justify-content-center align-items-center'>
          <div className='col-2'>
            <CustomListSelect
              fontSize={12}
              className="basic-single"
              options={['12M', '24M', '36M'].map((x,i)=>{
                return {value:x, label:x};
              })}
              value={{value:this.props.fund_params.funds_range, label:this.props.fund_params.funds_range}}
              isClearable={true}
              isSearchable={true}
              onChange={(e)=>this.props.changeModel('fund_params.funds_range', e==null ? null:e.value)}  
              placeholder="periodo..."
            />
          </div>
          <div className='col-2'>
            <Input 
              size="sm"
              type="date" 
              value={this.props.fund_params.funds_sel_date} onChange={(e)=>this.props.changeModel('fund_params.funds_sel_date',e.target.value)}
              placeholder="Fecha..."
            >
            </Input>
          </div>
          <div className='col-2'>
            <Button className="btn-corp"
              onClick={this.loadFunds}
            >
              Actualizar Búsqueda
            </Button>
          </div>
        </div>
      </Fragment>
    );
  }
  
  render() {
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Loading />
            </div>
          </div>
        );
      } else if(this.props.funds.isLoading){
        return(
          <div className="container">
              {this.renderHeader()}
              <div className="row justify-content-center m-5">
                <div className="col m-5">
                  <CustomLoading msg={`buscando ${this.props.fund_params.use_etf ? 'ETFs':'fondos'} recomendados`} icon="fa-filter" />
                </div>
              </div>
          </div>
        );
      } else if(this.props.funds.errMess){
          return(
              <div className="container">
                  {this.renderHeader()}
                  <div className="row justify-content-center m-5">
                    <div className="col m-5">
                      <h6>{this.props.funds.errMess}</h6>
                    </div>
                  </div>
              </div>
          );
      } else if(this.props.funds.data==null){
          return(
              <div className="container">
                  {this.renderHeader()}
                  <div className="row justify-content-center m-5">
                    <div className="col m-5">
                      <h6>No hay datos disponibles.</h6>
                    </div>
                  </div>
              </div>
          );
      } else {
        const filtered_df = filtered_data(this.props.funds.data.metrics_abs.filter(x=>x.Rango==this.props.fund_params.funds_range), this.state.search_text).sort(sort_by(this.state.sort_col));
        const filtered_active_df = this.props.funds.data.metrics_rel.filter(x=>x.Rango==this.props.fund_params.funds_range).sort(sort_by(this.state.sort_active_col));

        //filtered_json(jsonData, keys)
        const tks_list = [this.props.funds.data.bench_tk].concat(this.props.fund_params.funds_tks_list);
        const norm_series = this.props.funds.data.series.length==0 
                            ? null 
                            : series_normalize(this.props.funds.data.series.filter(item=>tks_list.every(x=>item[x]!='')).map(item=>filtered_json(item, ['Date'].concat(tks_list))), 
                                              tks_list, {'12M':'1Y', '24M':'2Y','36M':'3Y'}[this.props.fund_params.funds_range] || '3Y', 'Date', 1, 100);
        return (
          <div className="container">
            {this.renderHeader()}
            {this.props.funds.data!==null ?
            <Fragment>
              <div className="row mt-4 justify-content-center">
                <div className="col-12 mt-3" id="metrics_abs">
                  <h5>Métricas Absolutas</h5>
                  <div className="row justify-content-center" >
                    <div className="col-auto">
                    <p className="m-0"><small>{this.props.funds.data.msg}</small></p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-12" id="metrics_abs">
                  <a className='linkcol' href='#metrics_rel'>métricas relativas&darr;</a>
                  <a className='linkcol' href='#series'>{"    "}series&darr;</a>
                </div>
              </div>
              <div className="row m-4 justify-content-center align-items-center">
                <div className='col-3'>
                  <Input 
                    type="textarea" 
                    name="search_text" 
                    id="search_text" 
                    rows="1"
                    placeholder="Buscar..."
                    onChange={(e)=>{this.setState({search_text:e.target.value})}}
                  />
                </div>
                <div className='col-2'>
                  <Input 
                      type="select"
                      id="select_col"
                      onChange={(e)=>this.setState({sort_col:e.target.value})}
                      placeholder="Ordenar por..."
                      >
                      {[<option key={0} value={''}></option>].concat(['Ret. Promedio Anual.', 'Vol. Anual.', 'Sharpe Anual.', 'Drawdown'].map((x,i)=>{
                          return(
                              <option key={i+1} value={x}>{x}</option>
                          );
                      }))}
                  </Input>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className='col mt-3'>
                  {filtered_df!=null & filtered_df.length>0 ? 
                  <>
                    <div className='row justify-content-center align-items-center'>
                      <div className='col-6'>
                        <div className="row justify-content-center">
                          <div className='col-auto'>
                            <RenderVirtualTable 
                              data={remove_keys_json_array(filtered_df, ["VeRC 95%", "VeR 95%", "Sharpe Anual.", "Fecha Inicial", "Fecha Final", "Sortino Anual.", "Rango","Tiempo DD","Tiempo Recup."])} 
                              to_perc={[false,false,true,true,true]} 
                              cell_width={["250px", '120px', '60px', '60px', '60px']}
                              item_size={45}
                              fontsize={12}
                              style="black"
                            />
                          </div>
                        </div>

                        <div className='row justify-content-center align-items-center m-3'>
                          <div className='col-6'>
                            <p><small>{this.props.funds.data.msg}</small></p>
                          </div>
                        </div>
                      </div>
                      <div className='col-6'>
                        <p><small><b>{this.state.sort_col=='' ? "Ret. Promedio Anual." : this.state.sort_col}</b></small></p>
                        <BarPlot 
                           y={filtered_df.filter(k=>k[this.state.sort_col=='' ? "Ret. Promedio Anual." : this.state.sort_col]!=="").map(x=>x['Fondo']).map(x=>x.includes("-") ? x.split("-")[1].trim() : x)}
                           x={filtered_df.filter(k=>k[this.state.sort_col=='' ? "Ret. Promedio Anual." : this.state.sort_col]!=="").map(x=>x[this.state.sort_col=='' ? "Ret. Promedio Anual." : this.state.sort_col])}
                           layout={"vertical"}
                           angle={0}
                           ytype="category" 
                           xtype="number"
                           xpercAxis={true}
                           percTooltip={true}
                           width={500}
                           interval={0}
                           barsize={15}
                           fontsize={12}
                        />
                        </div>
                    </div>
                    <div className='row m-3 justify-content-center'>
                      <div className='col-1'>
                        <p><small>{filtered_df.length} isines.</small></p>
                      </div>
                      <div className='col-2'>
                        <CSVLink className='link-btn' data={filtered_df} filename="funds_data"><small>Descargar &darr;</small></CSVLink>
                      </div>
                    </div>
                    <div className="row justify-content-center">
                      <div className="col">
                        <hr/>
                      </div>
                    </div>
                    <div className="row mt-4 justify-content-center">
                      <div className="col-12 mt-3" id="metrics_rel">
                        <h5> <center><span>Métricas Relativas</span></center></h5>
                        <a className='linkcol' href='#metrics_abs'>métricas absolutas &uarr;</a>
                        <a className='linkcol' href='#series'>series &darr;</a>
                      </div>
                    </div>
                    <div className="row m-4 justify-content-center align-items-center">
                      <div className='col-2'>
                        <Input 
                            type="select"
                            id="select_col"
                            onChange={(e)=>this.setState({sort_active_col:e.target.value})}
                            placeholder="Ordenar por..."
                            >
                            {[<option key={0} value={''}></option>].concat(['Alpha Promedio Anual', 'Beta', 'TE', 'IR'].map((x,i)=>{
                                return(
                                    <option key={i+1} value={x}>{x}</option>
                                );
                            }))}
                        </Input>
                      </div>
                    </div>
                    <div className='row justify-content-center align-items-center'>
                      <div className='col-6'>
                        <div className='row justify-content-center align-items-center'>
                          <div className='col-auto'>
                            <RenderVirtualTable 
                              data={remove_keys_json_array(filtered_active_df, ["VeRC 95%", "Rango"])} 
                              to_perc={[false,false,true,true,false,true]} 
                              cell_width={["250px", '120px', '60px', '50px', '50px', '50px', '50px']}
                              item_size={45}
                              fontsize={12}
                              style="black"
                            />
                          </div>
                        </div>
                        <div className='row mt-4 justify-content-center align-items-center'>
                          <div className='col-6'>
                            <p><small>Benchmark: {this.props.funds.data.bench_tk}</small></p>
                          </div>
                        </div>
                      </div>
                      <div className='col-6'>
                        <p>{this.state.sort_col=='' ? "Alpha Promedio Anual" : this.state.sort_col}</p>
                        <BarPlot 
                           y={filtered_active_df.filter(k=>k[this.state.sort_active_col=='' ? "Alpha Promedio Anual" : this.state.sort_active_col]!=="").map(x=>x['Fondo']).map(x=>x.includes("-") ? x.split("-")[1].trim() : x)}
                           x={filtered_active_df.filter(k=>k[this.state.sort_active_col=='' ? "Alpha Promedio Anual" : this.state.sort_active_col]!=="").map(x=>x[this.state.sort_active_col=='' ? "Alpha Promedio Anual" : this.state.sort_active_col])}
                           layout="vertical"
                           angle={0}
                           ytype="category" xtype="number"
                           color="#000000"
                           xpercAxis={true}
                           percTooltip={true}
                           width={500}
                           interval={0}
                           barsize={15}
                           fontsize={12}
                        />
                        </div>
                    </div>
                    <div className='row m-3 justify-content-center'>
                      <div className='col-1'>
                        <p><small>{filtered_active_df.length} isines.</small></p>
                      </div>
                      <div className='col-2'>
                        <CSVLink className='link-btn' data={filtered_active_df} filename="funds_data"><small>Descargar &darr;</small></CSVLink>
                      </div>
                    </div>
                    <div className="row justify-content-center">
                      <div className="col">
                        <hr/>
                      </div>
                    </div>
  
                    <div className="row mt-4 justify-content-center">
                      <div className="col-12 mt-3" id="series">
                        <h5>Series</h5>
                        <a className='linkcol' href='#metrics_abs'>métricas absolutas&uarr;</a>
                        <a className='linkcol' href='#metrics_abs'>métricas relativas&uarr;</a>
                      </div>
                    </div>
                    <div className='row m-3 justify-content-center align-items-center'>
                      <div className='col-4'>
                        <CustomSelect
                          name="assets"
                          value={this.props.fund_params.funds_tks_list.map(x=>{
                            return(
                              {value:x, label:x}
                            );
                          })}
                          options={Object.keys(this.props.funds.data.series[0]).filter(k=>k!=this.props.funds.data.bench_tk & k!='Date').map(item=>{
                            return {value:item, label:item};
                            })}
                          onChange={(e)=>{this.props.changeModel('fund_params.funds_tks_list', e.map(x=>x.value))}}
                          itemSize={50}
                          className="basic-multi-select"
                          placeholder="seleccionar..."
                        />
                      </div>
                    </div>
                    <div className='row m-5 justify-content-center'>
                      <div className='col-auto'>
                       <MultLineTsPlot data={norm_series}
                         width={600}
                         xkey='Date'
                         ykeys={[this.props.funds.data.bench_tk].concat(this.props.fund_params.funds_tks_list)}
                         xtype='category'
                         ytype='number'
                         colors = {colors}
                         legend={true}
                         percTooltip={false}
                       />
                      </div>
                    </div>
                    <div className='row m-3 justify-content-center'>
                      <div className='col-2'>
                        <CSVLink className='link-btn' data={norm_series} filename="funds_series"><small>Descargar &darr;</small></CSVLink>
                      </div>
                    </div>
                    
        
                    </>
                      :<></>
                      }
                    </div>
                </div>
            </Fragment>
            :<Fragment>
            </Fragment>
            }
          </div>
        );
      }
    }
}
//export default Port;
export default withRouter(connect(mapStateToProps)(FundsSelect));